import * as React from 'react'
import { Legend, Series } from 'devextreme-react/chart'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const RemixChart: React.FunctionComponent = (props) => {
    return (
        <BPMChart {...props} title='Remix vs Singles' subTitle='By Downloads' type='pie'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('downloads/remix', options, signal).then((d) => {
                    return d.map(d => {
                        if (d.is_remix) {
                            d.type = 'Remix'
                        } else {
                            d.type = 'Single'
                        }
                        return d
                    })
                })
            }}>
            <Series
                valueField="count"
                argumentField="type">
            </Series>
            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/RemixChart.tsx